import { Injectable } from "@angular/core";
import { ApiService } from "app/core/http/api.service";
import { buildHttpOptions } from "app/core/http/BuildHttpOptions";
import { Observable } from "rxjs";

export interface MandatAdminDashboardSummaryResponse {
    yearlySummary: SalesYearlySummary;
    vehicleStock: VehicleStockData;
    topBuyers: MandatAdminDashboardTopBuyersDto[];
    topSellers: MandatAdminDashboardTopSellersDto[];
    delivered: number;
    upcomingDelivery: number;
    finishedTestDrives: number;
    upcomingTestDrives: number;
}

export interface VehicleStockData {
    arrived: VehicleStockDto[];
    sold: VehicleStockDto[];
    currentlyInStock: number;
    inStockTotalValue: number;
    soldVehicles: number;
    reserved: number;
    upcoming: number;
    purchased: number;
    tradeIn: number;
}

export interface VehicleStockDto {
    date: string; // ISO string for DateTime
}

export interface MandatAdminDashboardTopSellersDto {
    sellerId: string;
    sellerName: string;
    amountSold: number;
    contractsClosed: number;
    percentageOfTotalRevenue: number;
}

export interface MandatAdminDashboardTopBuyersDto {
    buyerId: string;
    buyerName: string;
    amountBought: number;
    percentageOfTotalBought: number;
}

export interface SalesYearlySummary {
    totalRevenue: number;
    totalExpenses: number;
    balance: number;
    totalCompleted: number;
    totalDelivered: number;
    totalAccounted: number;
    previousYearCompleted: number;
    previousYearDelivered: number;
    previousYearAccounted: number;
    contracts: ContractDto[];
}

export interface ContractDto {
    revenue: number;
    expense: number;
    date: string; // ISO string for DateTime
    status: string;
}


@Injectable({ providedIn: 'root' })
export class MandatAdminDashboardService {

    dashboardUrl = '/dashboard/mandat-admin/'; 
    constructor(private api: ApiService) { }


    //    [FromQuery] string VehicleStockPeriod,
    // [FromQuery] string TopSellersPeriod,
    // [FromQuery] string TopBuyersPeriod,

    getMandatAdminDashboardData(VehicleStockPeriod: string, year: number, TopSellersPeriod: string, TopBuyersPeriod: string): Observable<MandatAdminDashboardSummaryResponse> {

        const options = buildHttpOptions({
            extraParams: { vehicleStockPeriod: VehicleStockPeriod, year: year, topSellersPeriod: TopSellersPeriod, topBuyersPeriod: TopBuyersPeriod }
        });
  
        return this.api.get<MandatAdminDashboardSummaryResponse>(this.dashboardUrl + "summary", options);
    }
}